import { Component, Inject, OnInit, } from '@angular/core'
import { IQuestion } from 'app/interfaces/IQuestion'
import { MAT_DIALOG_DATA } from '@angular/material/dialog'
import { AuthService } from 'app/core/auth/auth.service'
import { environment } from 'environments/environment'

@Component({
    selector: 'app-chat',
    templateUrl: './chat.component.html',
    styleUrls: ['./chat.component.scss'],
    standalone: false
})
export class ChatComponent implements OnInit {

  iframeUrl: string = null

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      question: IQuestion,
      surveyId: string,
      activeLang: string
    },
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    this.iframeUrl = `${environment.chatAppUrl}/?token=${this.authService.accessToken}&questionKey=${this.data.question.key}&surveyId=${this.data.surveyId}&activeLang=${this.data.activeLang}`
  }

}
